import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'helpers/store'
import { CompaniesAction } from 'store/companies/CompaniesAction'
import { toast } from 'utils/toastUtils'

export const useRefreshSelectedCompany = (
    selectedCompanyId?: number
) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()

    return useCallback(async () => {
        if (!selectedCompanyId) {
            return false
        }

        try {
            await dispatch(CompaniesAction.fetchCompanyById(selectedCompanyId))
            return true
        } catch {
            toast.error(t('Failed to load company details'))
            return false
        }
    }, [dispatch, selectedCompanyId, t])
}

export default useRefreshSelectedCompany